import React, { useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';

import { myFirestore } from '../../config/MyFirebase';
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { Timestamp, collection, doc, onSnapshot, orderBy, query, setDoc, where } from "firebase/firestore";
const { v4: uuidv4 } = require('uuid');


export default function Register() {

    const navigate = useNavigate();


    const [errorCode, setErrorCode] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const [showErrorMessage, setShowErrorMessage] = useState(false);


    //User formik for registering
    const formik = useFormik({
        initialValues: {

            name: '',
            email: '',
            password: '',
            confirm_password: '',
        },
        validationSchema: Yup.object({

            name: Yup.string().required('Enter a name'),
            email: Yup.string().email('Invalid email address').required('Enter an email'),
            password: Yup.string()
                .required('Enter a password'),
            confirm_password: Yup.string()
                .required('Confirm password').oneOf([Yup.ref('password')], 'Passwords must match'),
        }),
        onSubmit: values => {
            // alert(JSON.stringify(values, null, 2));
            // console.log(values);









            //Create user to FirebaseAuth
            const auth = getAuth();
            createUserWithEmailAndPassword(auth, values.email, values.password)
                .then(async (userCredential) => {
                    const user = userCredential.user;
                    const user_id = userCredential.user.uid;
                    console.log(user);

                    //Get the free subscription_type
                    const q = query(collection(myFirestore, "subscriptions_types"), where("price_per_month", "==", 0.0));
                    const unsubscribe = onSnapshot(q, async (querySnapshot) => {
                        let freeSubscriptions: any[] = [];
                        querySnapshot.forEach((doc) => {
                            freeSubscriptions.push(doc.data());
                        });


                        // Register the free subscription for user
                        let subscriptionId = uuidv4();

                        let subscriptionTypeId = freeSubscriptions[0]["id"];
                        let titleSubscription = freeSubscriptions[0]["title"];
                        let descriptionSubscription =
                            freeSubscriptions[0]["description"];
                        let maxMessageDuration =
                            freeSubscriptions[0]["max_message_duration"];
                        let pricePerMonth = freeSubscriptions[0]["price_per_month"];
                        let subscriptionDuration =
                            freeSubscriptions[0]["subscription_duration"];

                        const newDate = new Date(new Date());
                        newDate.setDate(newDate.getDate() + subscriptionDuration);
                        let dateExpirationSubscription = Timestamp.fromDate(newDate);

                        await setDoc(doc(myFirestore, "subscriptions", subscriptionId), {
                            "id": subscriptionId,
                            "date_subscription": Timestamp.now(),
                            "paid": true,
                            "id_transaction": "",
                            "payment_mode": "",
                            "max_message_duration": maxMessageDuration,
                            "date_expiration_subscription": dateExpirationSubscription,
                            "price_per_month": pricePerMonth,
                            "title_subscription": titleSubscription,
                            "description_subscription": descriptionSubscription,
                            "subscription_duration": subscriptionDuration,
                            "subscription_type_id": subscriptionTypeId,
                            "user_id": user_id,
                            "timestamps": Timestamp.now(),


                        }).then(async () => {


                            // Add a new user document in collection "users"
                            //then redirect to home
                            await setDoc(doc(myFirestore, "users", user_id), {
                                actual_subscription_id: subscriptionId,
                                email: values.email,
                                id: user_id,
                                name: values.name,


                                title_subscription: titleSubscription,
                                subscription_type_id: subscriptionTypeId,
                                max_message_duration: maxMessageDuration,
                                price_per_month: pricePerMonth,
                                subscription_duration: subscriptionDuration,
                                date_subscription: Timestamp.now(),
                                description_subscription: descriptionSubscription,
                                date_expiration_subscription: dateExpirationSubscription,


                                timestamps: Timestamp.now(),
                            }).then(() => navigate('/dashboard/home'));

                        });
                    });



                })
                .catch((error) => {
                    const newErrorCode = error.code;
                    const newErrorMessage = error.message;
                    setErrorMessage(newErrorMessage);
                    setErrorCode(newErrorCode);

                    setTimeout(() => {
                        setShowErrorMessage(false);

                    }, 5000);
                });


        },
    });


    return (
        <div className='register-page'>
            <div className="register-box">
                <div className="register-logo">
                    <a href="/"><b>Copy&</b>Paste</a>
                </div>

                <div className="card">
                    <div className="card-body register-card-body">
                        <p className="login-box-msg">Register a new membership</p>
                        {errorMessage && showErrorMessage ? (<div className='alert alert-danger'>{errorMessage}</div>) : null}

                        <form onSubmit={formik.handleSubmit}>
                            <div className="input-group mb-3">
                                <input id="name"
                                    name="name"
                                    type="name"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.name}
                                    className={formik.touched.name && formik.errors.name ? ('form-control is-invalid') : "form-control"}
                                    placeholder="Name" />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-user"></span>
                                    </div>
                                </div>
                                {formik.touched.name && formik.errors.name ? (
                                    <div id="" className="error invalid-feedback">{formik.errors.name}</div>
                                ) : null}
                            </div>
                            <div className="input-group mb-3">
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.email}
                                    className={formik.touched.email && formik.errors.email ? ('form-control is-invalid') : "form-control"}
                                    placeholder="Email"

                                />                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-envelope"></span>
                                    </div>
                                </div>
                                {formik.touched.email && formik.errors.email ? (
                                    <div id="" className="error invalid-feedback">{formik.errors.email}</div>
                                ) : null}
                            </div>
                            <div className="input-group mb-3">
                                <input
                                    id="password"
                                    name="password"
                                    type="password"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.password}
                                    className={formik.touched.password && formik.errors.password ? ('form-control is-invalid') : "form-control"}
                                    placeholder="Password" />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-lock"></span>
                                    </div>
                                </div>
                                {formik.touched.password && formik.errors.password ? (
                                    <div id="" className="error invalid-feedback">{formik.errors.password}</div>
                                ) : null}
                            </div>
                            <div className="input-group mb-3">
                                <input
                                    id="confirm_password"
                                    name="confirm_password"
                                    type="password"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.confirm_password}
                                    className={formik.touched.confirm_password && formik.errors.confirm_password ? ('form-control is-invalid') : "form-control"}
                                    placeholder="Confirm Password" />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-lock"></span>
                                    </div>
                                </div>
                                {formik.touched.confirm_password && formik.errors.confirm_password ? (
                                    <div id="" className="error invalid-feedback">{formik.errors.confirm_password}</div>
                                ) : null}
                            </div>
                            <div className="row justify-content-center">
                                {/* <div className="col-8">
                                    <div className="icheck-primary">
                                        <input type="checkbox" id="agreeTerms" name="terms" value="agree" />
                                        <label htmlFor="agreeTerms">
                                            I agree to the <a href="#">terms</a>
                                        </label>
                                    </div>
                                </div> */}
                                <div className="col-4">
                                    <button type="submit" className="btn btn-primary btn-block">Register</button>
                                </div>
                            </div>
                        </form>

                        {/* <div className="social-auth-links text-center">
                            <p>- OR -</p>
                            <a href="#" className="btn btn-block btn-primary">
                                <i className="fab fa-facebook mr-2"></i>
                                Sign up using Facebook
                            </a>
                            <a href="#" className="btn btn-block btn-danger">
                                <i className="fab fa-google-plus mr-2"></i>
                                Sign up using Google
                            </a>
                        </div> */}

                        <a href="/" className="text-center">I already have a membership</a>
                    </div>
                </div>
            </div>

            <div style={{ 'marginLeft': '0px', }} className="mt-3">
                <strong>Copyright &copy; 2024 <a href="https://httpswebcopypaste">Copy&Paste</a>.</strong>
                All rights reserved.
                <div className="float-right d-none d-sm-inline-block">
                    <b>Version</b> 1.0.0
                </div>


            </div>
        </div>
    )
}
